// extracted by mini-css-extract-plugin
export default {"root":"TT5dN","content":"xbgTB","closeIcon":"dNFmn","arrow":"q3U6R"};